export default "__VITE_ASSET__CXifamlb__"